<template>
  <div class="d-flex justify-center">
    <div class="main-card mt-3">
      <div v-if="showSuccessMsg">
        <v-row justify="center">
          <v-col md="6" xs="12" sm="8">
            <v-card v-if="showSuccessMsg">
              <v-col
                cols="12"
                class="d-none d-sm-block mt-3 mb-3 hidden-sm-and-down"
              >
                <v-img
                  src="../assets/party-popper-icon.png"
                  contain
                  max-height="150"
                  alt="Party popper celebrating a successful resume submission"
                  class="mt-3 mb-2"
                ></v-img>
              </v-col>
              <v-card-title>
                Yor resume was successfully submitted!
              </v-card-title>
              <v-card-text>
                Once reviewed, we'll let you know at
                <b> {{ selEmail }} </b> - stay tuned!
              </v-card-text>
              <v-card-actions class="pl-3 pb-3">
                <v-btn
                  v-if="!$store.getters.userLoggedIn"
                  color="primary"
                  :href="this.submittedReviewRef"
                >
                  Check my review status
                </v-btn>
                <v-btn
                  v-if="$store.getters.userLoggedIn"
                  color="primary"
                  to="/myreviews"
                >
                  My reviews
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <v-stepper v-model="step" v-if="!showSuccessMsg" flat>
        <v-stepper-header style="box-shadow: none">
          <v-stepper-step :complete="step > 1" step="1">
            Select option
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2" lazy-validation>
            Additional data
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 3" step="3">
            Additional data
            <small>optional</small>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4"> Submit </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="pr-0 mr-0 pl-0 ml-0">
            <v-card elevation="0 ">
              <!-- <v-row>
                <v-col
                  md="6"
                  offset-md="3"
                  lg="4"
                  offset-lg="4"
                  class="d-flex flex-column"
                >
                  <pricing-option
                    :optionName="aiOption.name"
                    :optionPrice="aiOption.price"
                    :optionColor="aiOption.color"
                    :optionFeatures="aiOption.features"
                    :optionSelected="aiOption.selected"
                    :exampleUrl="aiOption.exampleUrl"
                    :onlyForLoggedInUsers="true"
                    @pricingOptionSelected="pricingSelected"
                  />
                </v-col>
              </v-row> -->
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                  v-for="o in aiOptions"
                  v-bind:key="o.name"
                  class="d-flex flex-column"
                >
                  <pricing-option
                    :optionName="o.name"
                    :optionPrice="o.price"
                    :optionColor="o.color"
                    :optionFeatures="o.features"
                    :optionSelected="o.selected"
                    :exampleUrl="o.exampleUrl"
                    @pricingOptionSelected="pricingSelected"
                  />
                </v-col>
              </v-row>
              <v-card-actions class="mt-5"> </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card>
              <v-form ref="refForm">
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="mb-3">
                        <span>Your resume file in .pdf format:</span>
                      </v-list-item-title>
                      <v-file-input
                        outlined
                        accept="application/pdf"
                        label="Resume file"
                        @change="uploadFile"
                        :disabled="uploading"
                        required
                        :rules="fileRules"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip small label color="primary">
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                      <v-progress-linear
                        indeterminate
                        v-if="uploading"
                      ></v-progress-linear>
                      <p
                        v-if="fileUploadError.length != 0"
                        class="mb-0 mt-1"
                        style="color: #b71c1c; line-height: 12px"
                      >
                        {{ fileUploadError }}
                      </p>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mb-2"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="mb-3">
                        <span>Your email so we can send you the report:</span>
                      </v-list-item-title>

                      <v-text-field
                        label="Email"
                        outlined
                        class="mt-2"
                        v-model="selEmail"
                        type="email"
                        required
                        :rules="emailRules"
                        ref="refEmail"
                      >
                        <v-icon slot="prepend"> mdi-email </v-icon>
                      </v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mb-2"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span>Choose companies you're interested in:</span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              small
                              v-bind="attrs"
                              v-on="on"
                              class="pb-1 ml-2"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>
                            We will match you with a reviewer from one of the
                            selected companies
                          </span>
                        </v-tooltip>
                      </v-list-item-title>
                      <div
                        v-if="
                          companiesLoadingError.length == 0 &&
                          companies.length == 0
                        "
                      >
                        <v-progress-circular
                          class="mt-2"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </div>
                      <div
                        class="d-inline-flex mt-1"
                        v-if="
                          companiesLoadingError.length == 0 &&
                          companies.length != 0
                        "
                      >
                        <v-chip
                          :class="
                            companiesAny ? 'primary accent-4 white--text' : ''
                          "
                          @click="companiesSelectedAny()"
                        >
                          Any tech
                        </v-chip>
                      </div>
                      <p v-if="companiesLoadingError.length != 0">
                        {{ companiesLoadingError }}
                      </p>
                      <div
                        class="d-inline-flex mt-1"
                        v-if="
                          companiesLoadingError.length == 0 &&
                          companies.length != 0
                        "
                      >
                        <v-chip
                          v-for="company in companies"
                          :key="company.Id"
                          :input-value="company.selected"
                          :class="
                            company.selected
                              ? 'primary accent-4 white--text'
                              : ''
                          "
                          class="mr-1"
                          @click="companiesSelectionChanged(company.Id)"
                        >
                          <v-avatar left>
                            <v-img :src="company.Logo_sm" :alt="`${company.Name} logo`"></v-img>
                          </v-avatar>
                          {{ company.Name }}
                        </v-chip>
                      </div>
                      <p
                        class="mb-0 mt-1"
                        style="color: #b71c1c; line-height: 12px"
                      >
                        {{ companiesError }}
                      </p>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-form>
              <v-card-actions class="mt-3">
                <v-btn @click="step = 1"> Back </v-btn>
                <v-spacer></v-spacer>
                <v-checkbox
                  v-model="skipValidation"
                  label="skip validation"
                  class="mr-4"
                  v-if="true"
                >
                </v-checkbox>
                <v-btn
                  color="primary"
                  @click="step1Continue()"
                  :disabled="uploading"
                >
                  Continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card elevation="0">
              <v-row>
                <v-col cols="12">
                  Add urls to job openings your are interested in, your reviewer
                  will analyze how well your resume matches them.
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Job opening 1"
                    class="mt-2"
                    v-model="url1"
                    required
                    :rules="urlRules"
                    ref="refUrl1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Job opening 2"
                    class="mt-2"
                    v-model="url2"
                    required
                    :rules="urlRules"
                    ref="refUrl2"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-card-actions class="mt-5">
                <v-btn text @click="step = 2"> Back </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step = 4"> Continue </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card elevation="0">
              <v-row>
                <v-col cols="12">
                  <v-list>
                    <v-list-item>File: {{ selFileName }} </v-list-item>
                    <v-list-item>File hash: {{ selFileHash }} </v-list-item>
                    <v-list-item>Email: {{ selEmail }} </v-list-item>
                    <v-list-item>Pricing: {{ selPricing }}</v-list-item>
                    <v-list-item>
                      Companies:
                      <v-chip v-if="companiesAny" class="ml-1"> Any </v-chip>
                      <v-chip
                        v-for="c in companies.filter((el) => el.selected)"
                        v-bind:key="c.Id"
                      >
                        {{ c.Name }}</v-chip
                      >
                    </v-list-item>
                    <v-list-item>
                      companies: {{ url1 }}, {{ url2 }}
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <p
                    class="mb-0 mt-1"
                    style="color: #b71c1c; line-height: 12px"
                    v-if="submitErrors.length > 0"
                  >
                    Submit errors:
                  </p>
                  <p
                    class="mb-0 mt-1"
                    style="color: #b71c1c; line-height: 12px"
                    v-for="err in submitErrors"
                    v-bind:key="err"
                  >
                    - {{ err }}
                  </p>
                </v-col>
              </v-row>
              <v-card-actions class="mt-3">
                <v-btn
                  text
                  @click="
                    {
                      if (selPricing == 'Full') {
                        step = 3;
                      } else {
                        step = 2;
                      }
                    }
                  "
                >
                  Back
                </v-btn>
                <v-spacer></v-spacer>
                <v-form @submit.prevent="submitResume">
                  <v-btn
                    color="primary"
                    class="mr-2"
                    type="submit"
                    :loading="btnLoading"
                    :disabled="btnLoading"
                  >
                    Submit
                  </v-btn>
                </v-form>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import PricingOption from "@/components/PricingOption.vue";
export default {
  components: {
    PricingOption,
  },
  data() {
    return {
      step: 1,
      skipValidation: false,
      companiesError: "",
      selFileName: "",
      selFileHash: "",
      selEmail: "",
      selPricing: "",
      btnLoading: false,
      submitting: false,
      submitErrors: [],
      showSuccessMsg: false,
      uploading: false,
      companiesAny: true,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "Invalid email",
      ],
      urlRules: [
        (v) => !!v || "URL is required",
        (v) => /^(http|https):\/\/[^ "]+$/.test(v) || "Invalid URL",
      ],
      fileRules: [
        (value) => {
          if (value == null) return "File is required";
          if (value.size > 10000000)
            return "Resume size should be less than 10 MB";
          return true;
        },
      ],
      // aiOption: {
      //   name: "AI",
      //   price: "FREE",
      //   color: "#9f9f9f",
      //   features: ["Basic AI analysis"],
      //   exampleUrl: "/review-status?reviewId=0-example",
      // },
      // --------------------------- AI options ---------------------------
      aiOptions: [
        {
          name: "BASIC",
          price: "FREE",
          color: "orange",
          features: [
            "Overall score",
            "Parsability",
            "Data checks",
            "Basic format checks",
          ],
          exampleUrl: "/ai-review-status?reviewId=0-example",
        },
        {
          name: "FULL",
          price: "INCLUDED IN PRO",
          color: "#4caf50",
          features: [
            "Overall score",
            "Parsability",
            "Data checks",
            "Data quality",
            "Full format checks",
            "Job hopping potential",
            "Education checks",
            "Certificates checks",
          ],
          exampleUrl: "/ai-review-status?reviewId=1-example",
        },
        {
          name: " TARGETED",
          price: "INCLUDED IN PRO",
          color: "#2196f3",
          features: [
            "Extended AI analysis",
            "Visual rating and review",
            "Content rating and review",
            "Overall rating and review",
            "Multiple feedback notes",
            "Dedicated job posting review",
          ],
          exampleUrl: "/ai-review-status?reviewId=2-example",
        },
      ],
      // --------------------------- Human reviewer options ---------------------------
      // pricingOptions: [
      //   {
      //     name: this.$consts.TIER_MAP.get(1).name,
      //     price: "$4.90",
      //     color: this.$consts.TIER_MAP.get(1).color,
      //     features: [
      //       "Basic AI analysis",
      //       "Personalized rating",
      //       "Feedback note",
      //     ],
      //     exampleUrl: "/review-status?reviewId=1-example",
      //   },
      //   {
      //     name: this.$consts.TIER_MAP.get(5).name,
      //     price: "$14.90",
      //     color: this.$consts.TIER_MAP.get(5).color,
      //     features: [
      //       "Extended AI analysis",
      //       "Personalized rating and review",
      //       "Content rating and review",
      //       "Overall rating and review",
      //       "Multiple feedback notes",
      //     ],
      //     exampleUrl: "/review-status?reviewId=5-example",
      //   },
      //   {
      //     name: this.$consts.TIER_MAP.get(10).name,
      //     price: "$49.90",
      //     id: 10,
      //     color: this.$consts.TIER_MAP.get(10).color,
      //     features: [
      //       "Extended AI analysis",
      //       "Visual rating and review",
      //       "Content rating and review",
      //       "Overall rating and review",
      //       "Multiple feedback notes",
      //       "Dedicated job posting review",
      //     ],
      //     exampleUrl: "/review-status?reviewId=10-example",
      //   },
      // ],
      companies: [],
      fileUploadError: "",
      companiesLoadingError: "",
      selection: "",
      submittedReviewRef: "",
      url1: "",
      url2: "",
    };
  },
  methods: {
    async uploadFile(file) {
      if (file == null) return;
      this.uploading = true;
      this.fileUploadError = "";
      let formData = new FormData();
      formData.append("file", file);
      this.selFile = file;
      this.selFileName = file.name;
      try {
        await this.$http
          .post(this.$consts.BE_ADDRESS + "/pub/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log("response.status: " + response.status);
            console.log("response.data.fileHash: " + response.data.fileHash);
            if (response.status === 200) {
              this.selFileHash = response.data.fileHash;
            } else {
              this.fileUploadError = "Upload error: " + response.status;
            }
          })
          .catch((error) => {
            this.fileUploadError = "Upload error: " + error;
          });
      } catch (err) {
        this.fileUploadError = "Upload error: " + err;
      } finally {
        this.uploading = false;
      }
    },
    pricingSelected(selName) {
      console.log("pricingSelected: " + selName);
      var option = this.aiOptions.find(({ name }) => name === selName);
      if (option) {
        this.selPricing = option.name;
        console.log("pricingSelected: " + this.selPricing);
        this.step = 2;
      } else {
        console.log("Error selecting pricing option");
      }
    },
    async submitResume() {
      this.submitErrors = this.presubmitValidation();
      if (this.submitErrors.length > 0) {
        return;
      }
      console.log("submitResume()");
      this.btnLoading = true;
      this.submitErrors = [];
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/pub/submitResume",
          {
            resumeHash: this.selFileHash,
            resumeFileName: this.selFileName,
            email: this.selEmail,
            companies: this.getCompaniesForSubmit(),
            //todo: replace/add some payment confirmation #
            pricing: this.selPricing,
          }
        );
        this.submittedReviewRef = resp.reviewRef;
        console.log("revRef: " + this.submittedReviewRef);
        this.showSuccessMsg = true;
      } catch (error) {
        this.submitErrors = error;
      } finally {
        this.btnLoading = false;
      }
    },
    getCompaniesForSubmit() {
      if (this.companiesAny) {
        return ["ANY"];
      }
      return this.companies.filter((c) => c.selected).map((c) => c.Id);
    },
    presubmitValidation() {
      var errors = [];
      if (!this.selPricing == null) {
        errors.push("Please select pricing option");
      }
      if (
        this.companies.filter((c) => c.selected).length > 0 &&
        this.companiesAny
      ) {
        errors.push(
          "Selectd companies error - both any and specific companies selected"
        );
      }
      if (
        this.companies.filter((c) => c.selected).length == 0 &&
        !this.companiesAny
      ) {
        errors.push("Please select at least one company");
      }
      // todo: validate whatever needs to be validated on submit site
      return errors;
    },
    async getSupportedCompanies() {
      this.companiesLoadingError = "";
      try {
        var resp = await this.$utils.callBackendGet(
          this,
          "/pub/getSupportedCompanies"
        );
        this.companies = resp;
        this.companies.forEach((e) => {
          e.selected = false;
        });
        console.log(JSON.stringify(this.companies));
      } catch (error) {
        console.log("getSupportedCompanies error: " + error);
        this.companiesLoadingError = "Error loading companies 1";
      }
    },
    validateCompanies() {
      // should never hapen technically but if it does, better catch it here
      // todo: report error to backend
      if (
        this.companies.filter((c) => c.selected).length == 0 &&
        !this.companiesAny
      ) {
        this.companiesError = "Incorret companies selection";
        return false;
      }
      this.companiesError = "";
      return true;
    },
    step1Continue() {
      // todo: remove "skipValidation"
      if (this.skipValidation || this.step1Valid()) {
        this.step++;
      }
    },
    step1Valid() {
      console.log("burny! step1valid()");
      return (
        this.$refs.refForm.validate() &&
        this.validateCompanies() &&
        this.fileUploadError.length == 0
      );
    },
    companiesSelectionChanged(id) {
      const selCompany = this.companies.find((c) => c.Id === id);
      const selCompanyIndex = this.companies.indexOf(selCompany);
      selCompany.selected = !selCompany.selected;
      const newArr = [...this.companies];
      this.companies = newArr;
      this.companiesAny = this.companies.filter((c) => c.selected).length == 0;
    },
    companiesSelectedAny() {
      // any is already selected
      if (this.companiesAny) {
        return;
      }
      // unselect all companies and select the any option'
      const c = [...this.companies];
      c.forEach((e) => {
        e.selected = false;
      });
      this.companies = c;
      this.companiesAny = true;
    },
  },
  mounted() {
    this.$utils.visit(this);
    this.selEmail = this.$store.getters.getUser;
    console.log("mounted() selEmail: " + this.selEmail);
    this.getSupportedCompanies();
  },
};
</script>

<style scoped>
.upload-div {
  max-height: 300px;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #f1f1f1;
  border-style: dashed;
  border-color: gray;
}
.main-card {
  width: 100vw;
  max-width: 1200px;
}
</style>
